import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, Gift } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const requestId = params.get("request_id");
  const [refunded, setRefunded] = useState(null);

  useEffect(() => {
    if (!requestId) return;
    (async () => {
      try {
        const { data } = await api.post(`/card-requests/${requestId}/release-credit`);
        if (data?.refunded > 0) setRefunded(Number(data.refunded));
      } catch {
        /* silently ignore — user may not be logged in */
      }
    })();
  }, [requestId]);

  return (
    <div className="min-h-screen bg-[var(--bg-1)] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="max-w-md w-full bg-[var(--bg-2)] border border-[var(--border-c)] rounded-2xl overflow-hidden shadow-[0_10px_60px_rgba(45,41,38,0.08)]"
      >
        <div className="h-1.5 bg-[#C6423B]" />
        <div className="p-8 md:p-10 text-center">
          <div className="mx-auto h-14 w-14 rounded-full flex items-center justify-center mb-5"
               style={{ background: "rgba(198,66,59,0.12)" }}>
            <XCircle size={26} className="text-[#C6423B]" />
          </div>
          <h1 className="font-serif text-3xl text-[var(--fg-1)] tracking-tight">Pagamento annullato</h1>
          <p className="mt-3 text-sm text-[var(--fg-3)] leading-relaxed">
            Nessun addebito è stato effettuato. Puoi riprovare quando vuoi dal link ricevuto via email
            {requestId ? <> per la richiesta <strong className="text-[var(--fg-1)]">#{requestId}</strong></> : null}.
          </p>
          {refunded !== null && (
            <div
              data-testid="payment-cancel-credit-refunded"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#4A8A6E]/12 text-[#3E7A5E] px-4 py-2 text-xs font-sans"
            >
              <Gift size={12} strokeWidth={2.2} />
              Credito referral ripristinato: € {refunded.toFixed(2).replace(".", ",")}
            </div>
          )}
          <div className="mt-8">
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 rounded-full border border-[var(--border-c)] hover:border-[var(--fg-2)] text-[var(--fg-1)] px-6 py-3 text-sm font-sans"
              style={{ transition: "border-color 0.2s ease" }}
            >
              <ArrowLeft size={14} /> Torna alla dashboard
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
